import pageDefaultMixin from "@/mixins/page/pageDefaultMixin";
import pageListMixin from "@/mixins/page/pageListMixin";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service"
import ui from "@/assets/scripts/ui";

export default {
    mixins: [pageDefaultMixin, pageListMixin],
    data() {
        return {
            path: "",
            busy: false,
            exportId: 0,
            codeLabel: "",
            name: "",
            enableFocusOutAction: true,
            onSending: false,
            mount: false,
            modalSearch: false,
            stopSearch: false,
            fastSearchCursor: -1,//Posição do cursor
            enableCloseFastSearch: true,//Trava fechamento da listagem para execução de alguma tarefa
            fastSearchList: [],
            modalId: "",
            primaryKeyColumn: "",
            codeLabelKeyColumn: "",
            localFixed: false,
        }
    },
    props: {
        value: {
            type: null,
            default: ""
        },
        disableName: Boolean,
        blockEnterpriseId: {
            type: Number,
            default: 0
        },
        addError: {
            type: String,
            default: ""
        },
        required: {/*ATENÇÃO PARA FUNCIONAR É NECESSÁRIO ENVIAR O STATUS E COMANDO*/
            type: Boolean,
            default: false
        },
        status: {
            type: String,
            default: "",
        },
        fixed: Boolean,
        command: {
            type: String,
            default: "insert",
        }
    },
    mounted() {

        this.getResume(this.value)
        this.setFixed()

    },
    methods: {

        setFixed() {

            this.localFixed = this.fixed

            if (this.command === 'delete' || this.command === 'view') {
                this.localFixed = true
            }

        },

        getDetailSearchList(item) {

            return "<div>" + ui.highlightSearch(item[this.codeLabelKeyColumn], this.codeLabel) + "</div><small>" + ui.highlightSearch(item.name, this.codeLabel) + "</small>"

        },

        onModalSearchClose() {
            this.modalSearch = false
        },

        onSelected(exportId) {
            this.onModalSearchClose()
            this.$emit("input", exportId)
        },

        openModalSearch() {

            document.activeElement.blur()

            this.modalSearch = true

            if (this.mount) {
                this.$bvModal.show(this.modalId)
            } else {

                this.mount = true

                setTimeout(() => {
                    this.$bvModal.show(this.modalId)
                }, 200)

            }

        },


        async setFastSearchByIndex(index) {

            this.codeLabel = this.fastSearchList[index][this.codeLabelKeyColumn]
            this.enableFocusOutAction = false

            await this.getExportId()

            this.enableFocusOutAction = true


        },

        clearFastSearch() {
            this.fastSearchCursor = -1
            this.enableCloseFastSearch = true
            this.fastSearchList = []
        },

        executeFastSearch(event) {

            if (this.fastSearchList.length > 0 && !this.stopSearch) {

                if (event.which === 27) {
                    //Parar de pesquisar e fechar

                    this.stopSearch = true
                    this.clearFastSearch()

                } else if (event.which === 38) {
                    //Subir

                    this.fastSearchCursor--;

                    if (this.fastSearchCursor < 0) {
                        //Não inicializado e será o último
                        this.fastSearchCursor = this.fastSearchList.length - 1
                    }

                } else if (event.which === 40) {
                    //Descer

                    this.fastSearchCursor++;

                    if (this.fastSearchCursor > (this.fastSearchList.length - 1)) {
                        //Não inicializado e será o último
                        this.fastSearchCursor = 0
                    }

                } else if (event.which === 13) {

                    //Caso não selecionado, será subentendido o primeiro da lista
                    if (this.fastSearchCursor < 0)
                        this.fastSearchCursor = 0

                    this.codeLabel = this.fastSearchList[this.fastSearchCursor][this.codeLabelKeyColumn]

                    setTimeout(() => {
                        document.activeElement.blur()
                    }, 50)


                } else {
                    this.getFastSearchTop()
                }

            } else {
                this.getFastSearchTop()
            }

        },

        async getFastSearchTop() {

            if (!this.stopSearch) {
                if (this.codeLabel !== '') {

                    let params = new URLSearchParams()
                    params.set("default", this.codeLabel)
                    params.set("top", "5")

                    await crudGeneral.list(this.path + "/resumeTop", params)
                        .then(list => {
                            this.fastSearchList = list
                        })
                        .catch(error => {
                            console.log('Erro externo: ' + error)
                        })

                } else {
                    this.clearFastSearch()
                }
            } else {

                if (this.codeLabel === '') {
                    this.stopSearch = false
                    this.clearFastSearch()
                }

            }


        },

        searchFocusIn() {

            //Desabilita o submit, caso existir para evitar que o produto ainda não tenha carregado ou esteja em alteração
            this.setDisabledButtonSubmit(true)

        },

        async searchFocusOut() {

            setTimeout(async () => {
                this.stopSearch = false
                this.clearFastSearch()

                if (this.enableFocusOutAction) {
                    await this.getExportId()
                }

            }, 200)

        },

        async getExportId() {

            if (this.codeLabel === '') {
                this.exportId = 0
            } else {
                await this.getResumeCodeLabel('code', this.codeLabel)
            }

            this.$emit("input", this.exportId)

            //Emite somente se for encontrado corretamente
            if (this.exportId > 0)
                this.$emit("focusout", this.exportId)

            //Saida do foco habilita novamente
            setTimeout(() => {
                //Tempo necessário para finalizar carregamento do produto
                this.setDisabledButtonSubmit(false)
            }, 500)

        },

        async getResumeCodeLabel(type, param) {

            await crudGeneral.getResume(this.path, type, param, false).then(resume => {

                this.exportId = resume[this.primaryKeyColumn]
                this.codeLabel = resume[this.codeLabelKeyColumn]
                this.name = resume.name
                this.busy = false
                this.$emit("onResume", resume)

            }).catch(error => {

                if (error.response) {
                    if (error.response.status === 500) {
                        ui.msg(this, 'Informação', error.response.data.message)
                    }
                } else if (error !== '') {
                    ui.msg(this, "Erro", error)
                }
            })

        }


    },
    watch: {
        fixed(v) {
            this.localFixed = v
            this.setFixed()
        },
        command() {
            this.setFixed()
        },

    },
}


